// ---------------------------------------------------------------------------
// useReduceMotion (AL-1850)
// ---------------------------------------------------------------------------
// The "Reduce motion" switch in the preferences popover. It starts from what
// the operating system already says — someone who asked their machine for
// less motion should not have to ask again here — and once the switch is
// touched, the choice is remembered and wins.
//
// Applying it is a class on <html>; the rule that reads it lives in index.css.
// ---------------------------------------------------------------------------

import { useEffect } from 'react';
import { usePersistedFlag } from './usePersistedFlag';

export const REDUCE_MOTION_KEY = 'v11.shell.reduceMotion';
export const REDUCE_MOTION_CLASS = 'reduce-motion';

export function prefersReducedMotion(): boolean {
  try {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch {
    return false;
  }
}

export function useReduceMotion(): readonly [boolean, () => void] {
  const [enabled, , toggle] = usePersistedFlag(REDUCE_MOTION_KEY, prefersReducedMotion());

  useEffect(() => {
    document.documentElement.classList.toggle(REDUCE_MOTION_CLASS, enabled);
  }, [enabled]);

  return [enabled, toggle] as const;
}
